const Strings = {
  PASSWORDS_DONT_MATCH: {
    SE: 'Lösenorden matchar ej',
    EN: 'The passwords does not match'
  },
  PASSWORDS_DONT_MATCH_INFO: {
    SE: 'Lösenorden matchar ej, var god försök igen.',
    EN: 'The passwords does not match, please try again.'
  },
  PASSWORD_UPDATED: {
    SE: 'Lösenordet har uppdaterats',
    EN: 'The password was updated'
  },
  PASSWORD_UPDATED_INFO: {
    SE: 'Lösenordet har uppdaterats.',
    EN: 'The password has been updated.'
  },
  NEW_PASSWORD: {
    SE: 'Nytt lösenord',
    EN: 'New password'
  },
  PASSWORD: {
    SE: 'Lösenord',
    EN: 'Password'
  },
  REPEAT_PASSWORD: {
    SE: 'Upprepa lösenord',
    EN: 'Repeat password'
  },
  CHANGE_PASSWORD: {
    SE: 'Byt lösenord',
    EN: 'Change password'
  },
  MANDATORY_FIELDS: {
    SE: 'Fyll i alla obligatoriska fält',
    EN: 'Enter all mandatory fields'
  },
  MANDATORY_FIELDS_INFO: {
    SE: 'Var god fyll i alla obligatoriska fält och försök igen.',
    EN: 'Please enter all the mandatory fields and try again.'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/ResetPassword/strings.js